import { Link } from 'react-router-dom';
import { getHotArticles, getCategories, buildCategoryPath, buildArticlePath, formatViews } from '@/utils/articles';

export default function ArticleSidebar() {
  const hotList = getHotArticles(5);
  const categories = getCategories();

  return (
    <aside className="flex flex-col gap-5 lg:sticky lg:top-28">
      <div className="rounded-xl border border-background-200 bg-background-50 p-5">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-fire-line text-lg text-accent-600" />
          今日热榜
        </h2>
        <ol className="mt-3 flex flex-col gap-1">
          {hotList.map((item, index) => (
            <li key={item.id}>
              <Link to={buildArticlePath(item.id)} className="group flex items-start gap-3 rounded-lg px-2 py-2.5 hover:bg-background-100">
                <span
                  className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded font-heading text-xs font-bold ${
                    index < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                  }`}
                >
                  {index + 1}
                </span>
                <span className="line-clamp-2 flex-1 text-sm text-foreground-800 transition-colors group-hover:text-primary-600">
                  {item.title}
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-xl border border-background-200 bg-background-50 p-5">
        <h2 className="font-heading text-base font-bold text-foreground-950">相关栏目</h2>
        <div className="mt-3 flex flex-wrap gap-2">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={buildCategoryPath(category.slug)}
              className="rounded-full bg-background-200 px-3 py-1 text-xs text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
            >
              {category.name}
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-xl border border-primary-100 bg-primary-50 p-5">
        <p className="text-sm font-medium text-foreground-900">想第一时间看到新爆料？</p>
        <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">
          本站每日 09:00 与 20:00 集中更新，热点事件随时补更。
        </p>
        <span className="mt-3 flex items-center gap-1 text-xs text-primary-700">
          <i className="ri-eye-line" />
          今日已有 {formatViews(86420)} 人次浏览
        </span>
      </div>
    </aside>
  );
}